import axios from 'axios';
import jwtDecode from 'jwt-decode';
import moment from 'moment';

const API_URL = 'https://api-ebov.fly.dev';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(async req => {
  const token = localStorage.getItem('@eBov:Token');
  const refreshToken = localStorage.getItem('@eBov:RefreshToken');

  if (token) {
    const decoded = jwtDecode<any>(token);
    const isExpired = moment().unix() >= decoded.exp;

    if (!isExpired) return req;

    try {
      const response = await axios.get(`${API_URL}/refresh-token`, {
        params: {
          token: refreshToken,
        },
      });

      const { newToken, newRefreshToken } = response.data;
      api.defaults.headers.authorization = `Bearer ${newToken}`;
      req.headers.authorization = `Bearer ${newToken}`;

      localStorage.setItem('@eBov:Token', newToken);
      localStorage.setItem('@eBov:RefreshToken', newRefreshToken);
    } catch (err) {
      console.log('Error!');
      console.log(err);
    }
  }

  return req;
});

export default api;
